const PATH_FTP = "https://khaktus.fr/Cookyn/React"
// const API = "http://192.168.1.19:1313/api"
const API = "https://api.skore.ftcissy.fr/api"
// const SOCKET = "http://192.168.1.19:1313"
const SOCKET = "https://api.skore.ftcissy.fr"
// eslint-disable-next-line
export default {PATH_FTP, API, SOCKET}
